/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_No_Activity_HintInputs */

const en_dashboard_no_activity_hint = /** @type {(inputs: Dashboard_No_Activity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a resume or track a job to get started`)
};

const de_dashboard_no_activity_hint = /** @type {(inputs: Dashboard_No_Activity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle einen Lebenslauf oder tracke einen Job, um loszulegen`)
};

const fr_dashboard_no_activity_hint = /** @type {(inputs: Dashboard_No_Activity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creez un CV ou suivez un emploi pour commencer`)
};

const es_dashboard_no_activity_hint = /** @type {(inputs: Dashboard_No_Activity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un curriculo o registra un empleo para comenzar`)
};

const it_dashboard_no_activity_hint = /** @type {(inputs: Dashboard_No_Activity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un CV o monitora un lavoro per iniziare`)
};

const nl_dashboard_no_activity_hint = /** @type {(inputs: Dashboard_No_Activity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een cv of volg een baan om te beginnen`)
};

const pl_dashboard_no_activity_hint = /** @type {(inputs: Dashboard_No_Activity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utworz CV lub sledz oferte pracy, aby zaczac`)
};

const fi_dashboard_no_activity_hint = /** @type {(inputs: Dashboard_No_Activity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo ansioluettelo tai seuraa työpaikkaa aloittaaksesi`)
};

const da_dashboard_no_activity_hint = /** @type {(inputs: Dashboard_No_Activity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret et CV eller spor et job for at komme i gang`)
};

const sv_dashboard_no_activity_hint = /** @type {(inputs: Dashboard_No_Activity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa ett CV eller foljj ett jobb for att borja`)
};

/**
* | output |
* | --- |
* | "Create a resume or track a job to get started" |
*
* @param {Dashboard_No_Activity_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_no_activity_hint = /** @type {((inputs?: Dashboard_No_Activity_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_No_Activity_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_no_activity_hint(inputs)
	if (locale === "fr") return fr_dashboard_no_activity_hint(inputs)
	if (locale === "es") return es_dashboard_no_activity_hint(inputs)
	if (locale === "it") return it_dashboard_no_activity_hint(inputs)
	if (locale === "nl") return nl_dashboard_no_activity_hint(inputs)
	if (locale === "pl") return pl_dashboard_no_activity_hint(inputs)
	if (locale === "fi") return fi_dashboard_no_activity_hint(inputs)
	if (locale === "da") return da_dashboard_no_activity_hint(inputs)
	if (locale === "sv") return sv_dashboard_no_activity_hint(inputs)
	return en_dashboard_no_activity_hint(inputs)
});